import { IUserProfile } from './../types/userTypes';
import {Dispatch} from 'redux';
import {userType} from '../constanst/index';

export const fetchUser=(user:IUserProfile)=>{
    return {
        type:userType.FETCH_USER_PROFILE,
        payload:user
    }
}

export const fetchUserProfile=(user:IUserProfile)=>{
    return(dispatch:Dispatch)=>{
        dispatch(fetchUser(user));
    }
}

